import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-alignrightsimple",
  "use": "icon-th-alignrightsimple-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-alignrightsimple\">\n<path d=\"M29 7V25C29 25.2652 28.8946 25.5196 28.7071 25.7071C28.5196 25.8946 28.2652 26 28 26C27.7348 26 27.4804 25.8946 27.2929 25.7071C27.1054 25.5196 27 25.2652 27 25V7C27 6.73478 27.1054 6.48043 27.2929 6.29289C27.4804 6.10536 27.7348 6 28 6C28.2652 6 28.5196 6.10536 28.7071 6.29289C28.8946 6.48043 29 6.73478 29 7ZM25 12V20C25 20.5304 24.7893 21.0391 24.4142 21.4142C24.0391 21.7893 23.5304 22 23 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V12C2 11.4696 2.21071 10.9609 2.58579 10.5858C2.96086 10.2107 3.46957 10 4 10H23C23.5304 10 24.0391 10.2107 24.4142 10.5858C24.7893 10.9609 25 11.4696 25 12ZM23 12H4V20H23V12Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-alignrightsimple.svg
// module id = fGB/
// module chunks = 84